<template>
  <sModal
    v-if="value"
    v-model="showModal"
    closable
    :title="$t('groupOfAccreditation.reasonReturn')">
    <template #activator>
      <sButton
        :data-qa="dataQa"
        icon="info"
        small
        type="text"
        @click.stop="showModal=true"/>
    </template>
    <div>{{ value }}</div>
    <template #footer>
      <div
        key="footer"
        class="flex">
        <sButton
          key="btn-apply"
          :data-qa="`${dataQa}-close`"
          @click="showModal = false">
          {{ $t('Common.Close') }}
        </sButton>
        <sButton
          class="my-auto ml-2"
          :data-qa="`${dataQa}-copy`"
          icon="copy"
          type="text"
          @click="copyValue">
          {{ $t('Common.Copy') }}
        </sButton>
      </div>
    </template>
  </sModal>
</template>
<script>
export default {
  name: 'ModalGroupAccreditationsFeedback',
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    copyValue() {
      navigator.clipboard.writeText(this.value)
      this.$notice.info({
        title: this.$t('Common.Copy'),
        message: this.$t('Common.copied'),
        duration: 10
      })
      this.showModal = false
    }
  },
  computed: {},
  components: {},
  created() {},
  props: {
    value: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: ''
    },
  },
}
</script>
<style scoped lang="scss">
</style>
